import React, { useState, useEffect } from 'react'
import injectSheet from 'react-jss'
import { Modal, ModalContent, ModalFooter } from 'pobble-components/dist/modal'
import Button from 'pobble-components/dist/button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPrint } from '@fortawesome/pro-solid-svg-icons/faPrint'
import usePresentationPrint from '../use-presentation-print/use-presentation-print'
import { apiGetPresentation } from '../../common/api/lesson'
import Checkmark from './animated-checkmark'
import {
  useFeatureCounter,
  SubsCrown
} from 'pobble-components/dist/subscriptions'
import { useSubscriptionDetails } from 'pobble-components/dist/subscriptions/utils'
import Cookies from 'js-cookie'
import { UpsellModal } from '../pages/prompt/upsell'
import posthog from 'posthog-js'

const styles = ({ COLORS }) => ({
  content: {
    minWidth: 'auto',
    width: '300px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  icon: {
    marginTop: '.1em',
    marginBottom: '.2em',
    fontSize: '6em',
    color: COLORS.TEXT.LIGHT_GREY.NORMAL
  },
  freeTrialWarning: {
    padding: '16px 12px',
    borderRadius: '8px',
    background: '#fee43342',
    color: 'var(--gray)',
    marginTop: '24px',
    textAlign: 'center',
    '& strong': {
      display: 'block',
      marginTop: '8px'
    }
  }
})

const PrintModal = ({ classes, id, isOpen, ...props }) => {
  const [presentation, setPresentation] = useState(null)
  const [upsellModalOpen, setUpsellModalOpen] = useState(false)

  const { PrintComponent, print, printInProgress } = usePresentationPrint(
    presentation,
    {
      onAfterPrint: () => {
        if (freeTrial) {
          const freePrints = Cookies.get('freePrints') || 10
          Cookies.set('freePrints', freePrints - 1)
        }
        return props.requestClose()
      }
    }
  )

  const { freeTrial } = useSubscriptionDetails()

  const freePrints = Cookies.get('freePrints') || 10

  const [printPresentationCounter, printPresentationSp] = useFeatureCounter(
    'PresentationPrint',
    sp => sp.lesson_planning.print_presentation
  )

  useEffect(
    () => {
      if (id) {
        apiGetPresentation(id, {
          include:
            'presentation.asset,presentation.lesson,presentation.account.names,presentation.account.avatar,presentation.names,presentation.image,presentation.details,presentation.slides,presentation.slide.details,presentation.slide.type,presentation.year_groups,presentation.year_group.order,presentation.recommended_until,presentation.category,presentation.flag.data'
        })
          .then(res => setPresentation(res.data.presentation))
          .catch()
      }
    },
    [id]
  )

  return (
    <>
      <Modal isOpen={isOpen} {...props}>
        <ModalContent legacy className={classes.content}>
          <Checkmark ready={!!presentation} />
          <span>
            {!presentation && 'Preparing for print...'}
            {!!presentation && 'Ready to be printed'}
          </span>
          {freeTrial &&
            freePrints < 5 && (
              <div className={classes.freeTrialWarning}>
                You have 10 free prints during your free-trial. After your free
                trial ends you will be able to print unlimited resources with a
                subscription.<br />
                <strong>
                  {Cookies.get('freePrints') || 10} free prints left
                </strong>
              </div>
            )}
        </ModalContent>
        <ModalFooter alignRight childrenGap>
          <Button simple tall action={props.requestClose}>
            Close
          </Button>
          <Button
            minw
            icon={
              printPresentationSp.restricted ? (
                <SubsCrown accent />
              ) : (
                <FontAwesomeIcon icon={faPrint} />
              )
            }
            pending={printInProgress}
            disabled={
              !presentation || (freeTrial && Cookies.get('freePrints') === '0')
            }
            tall
            action={() => {
              if (printPresentationSp.restricted) {
                posthog.capture('triggers upsell modal from print', {
                  lesson_category: presentation.category,
                  lesson_id: presentation.id,
                  lesson_title: presentation.title
                })
                setUpsellModalOpen(true)
                return props.requestClose()
              }
              print()
              printPresentationCounter()
            }}>
            {printInProgress && 'Loading...'}
            {!printInProgress && 'Print'}
          </Button>
        </ModalFooter>
        <PrintComponent />
      </Modal>
      <UpsellModal
        id="print"
        isOpen={upsellModalOpen}
        requestClose={() => setUpsellModalOpen(false)}
      />
    </>
  )
}

export default injectSheet(styles)(PrintModal)
